import { cn } from "@/lib";
import { ErrorMessage, Field } from "formik";

interface TProps {
    errors: any;
    touched: any;
    label: string;
    name: string;
    placeholder: string;
    required: boolean;
    as?: string;
    type?: string;
    disabled?: boolean;
    className?: string;
}

const FormInput = ({ errors, touched, label, name, placeholder, className, required, disabled = false, as = 'input', type = 'text'}: TProps) => {
    return (
        <div className="flex flex-col items-start justify-center">
            <label className="mb-1.5 block text-xs font-semibold text-gray-700" htmlFor={name}>
                {label} {required && <span className="text-primary">*</span>}
            </label>
            <Field
                id={name}
                name={name}
                placeholder={placeholder}
                disabled={disabled}
                as={as}
                type={type}
                className={cn(
                    "block w-full rounded-lg border bg-gray-50 px-4 py-3 text-sm text-gray-900 transition focus:border-primary focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary/20",
                    errors.name && touched.name ? "border-red-300 focus:border-red-500 focus:ring-red-200" : "border-gray-200",
                    className
                )}
            />
            <ErrorMessage name={name} component="div" className="mt-1 text-[10px] font-medium text-red-600" />
        </div>
    );
}

export default FormInput;